import {
    Logout as LogoutIcon,
    Settings as SettingsIcon
} from '@volkswagen-onehub/icons-core';
import React from 'react';
import styled from 'styled-components';
import {LoginFlyoutFooterLink} from '../../../components/LoginFlyout';
import {
    useLoginAlertService,
    useLoginFlyoutService,
    useLoginStore,
    useSpaAsyncConfig
} from '../../../context';
import {createBtnLogoutClick} from './createBtnLogoutClick';
import {createBtnSettingsClick} from './createBtnSettingsClick';
import {
    Text,
    TextTag,
    TokenTextAppearance
} from '@volkswagen-onehub/components-core';
import {CmsTextLink} from '../../../components/links/CmsTextLink';
import {getIcon} from '../../../utils/getMappedIcon';

const StyledIconRow = styled.div`
    display: flex;
    justify-content: space-between;
    padding: ${props => props.theme.size.static400} 0;
`;

export const UtilityLoggedInFooter = () => {
    const {utilityNavigationModel} = useSpaAsyncConfig();
    const loginStore = useLoginStore();
    const loginFlyoutService = useLoginFlyoutService();
    const loginAlertService = useLoginAlertService();
    const {customerType} = loginStore;
    const utilityNavProfileItem =
        customerType === 'private'
            ? utilityNavigationModel.utilityNavProfileItems?.[0]
            : utilityNavigationModel.utilityNavProfileItemsCommercial?.[0];
    const handleBtnSettingsClick = createBtnSettingsClick(loginStore);
    const handleBtnLogoutClick = createBtnLogoutClick(
        loginStore,
        loginFlyoutService,
        loginAlertService,
        utilityNavigationModel.btnCloseLabel
    );

    // use localized profile link if available or the default URL to ID profile app of IDK/CIDK otherwise empty
    let settings;
    if (utilityNavProfileItem) {
        const icon = utilityNavProfileItem.icon ? (
            getIcon(utilityNavProfileItem.icon, 'default')
        ) : (
            <SettingsIcon aria-hidden />
        );
        settings = (
            <Text appearance={TokenTextAppearance.copy100} tag={TextTag.span}>
                <CmsTextLink
                    icon={icon}
                    href={utilityNavProfileItem.linkHref}
                    aria-label={utilityNavProfileItem.linkTitle}
                    target={utilityNavProfileItem.linkTarget}
                    contentId={'utility-settings'}
                >
                    {utilityNavProfileItem.linkLabel}
                </CmsTextLink>
            </Text>
        );
    } else if (handleBtnSettingsClick) {
        settings = (
            <LoginFlyoutFooterLink
                key="flyoutSettingsLink"
                href="#"
                label={utilityNavigationModel.btnSettingsLabel}
                icon={<SettingsIcon aria-hidden />}
                onClick={handleBtnSettingsClick}
                contentId={'utility-settings'}
            />
        );
    } else {
        settings = undefined;
    }

    return (
        <StyledIconRow>
            {settings}
            <LoginFlyoutFooterLink
                key="flyoutLogoutLink"
                href="#"
                label={utilityNavigationModel.btnLogoutLabel}
                icon={<LogoutIcon aria-hidden />}
                onClick={handleBtnLogoutClick}
                contentId={'utility-logout'}
            />
        </StyledIconRow>
    );
};
